<template>
    <nav class="jobs-nav" aria-label="breadcrumb" ref="tableContainer">
            <div class="job-details">
                <div class="title">{{  vacancy.jobTitle }}</div>
               <div class="sub-details">
                    <div class="jobType">{{  vacancy.jobType }} &#x1F784; {{  vacancy.location }} &#x1F784; {{ vacancy.closingDate }}</div>
               </div>
            </div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link class="breadcrumb-link" 
                    :to="{ name:'applicants-list'}">Applicants</router-link></li>
                <li class="breadcrumb-item"><router-link class="breadcrumb-link"
                        :to="{name: 'shortlisted-list'}">Shortlist</router-link></li>
            </ol>
        </nav>

    <div class="tables theme-card" ref="tableShortlisted">
        <div class="widget-loading-indicator" v-if="loading">
            <LoadingIndicator v-if="loading" message="Loading Applicants"/>
        </div>
        <div v-if="!loading" class="table-header">
                <div class="table-title"><span>Applicants</span> <span v-if="applicantsMeta != null" title="Total Applicants" class="total">{{ applicantsMeta.totalCount }}</span></div>
                <div v-if="applicantsMeta != null" class="page-count" :title="'page ' + currentPage + ' of ' + applicantsMeta.totalPages">{{currentPage}}/{{ applicantsMeta.totalPages > 0 ? applicantsMeta.totalPages : 1 }}</div>
            </div>
            <div class="table-content">

                        <div v-if="!loading" class="table-tools" style="display:flex;justify-content: space-between;align-items:center;">
                                <div class="table-actions">
                                    <button type="button" class="search-btn" :disabled="searchBtnClicked" @click="loadInitPageForSearch">
                                        <SearchIcon/>
                                    </button>
                                    <input type="text" v-model="searchBody.searchTerm"  class="search-query" placeholder="Search Applicants" @keyup.enter="loadInitPageForSearch">
                                    <button type="button" class="search-btn" :disabled="cancelBtnClicked" style="background:var(--background)!important;color:var(--page-header)!important;margin-left:0.5rem;" v-if="isSearch" @click="loadInitPage">
                                        <CloseIcon/>
                                    </button>
                                </div>  
                                    <button class="delete-all" @click="showDeleteAllOptions" :disabled="deleteAllBtnClicked">
                                    
                                        <span style="font-size:0.9rem;">{{ deleteAllBtnClicked == true ? 'Deleting...' : 'Delete All' }}</span></button>
                        </div>


                    <table v-if="!loading" id="myTable" class="display">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>&nbsp;</th>
                                <th style="text-align:center;">Emailed Docs</th>
                                <th>&nbsp;</th>
                                <th style="text-align:center;">Sent Platform CV</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th> <!-- icon buttons here -->
                            </tr>
                        </thead>
                        <tbody>
                            <!-- item -->
                            <!-- <tr> -->
                            <tr v-for="applicant in applicants">
                                <td title="User's Fullname"><div class="row-context">{{applicant.fullname}}</div></td>
                                <td></td> 
                                <td class="checkmark-column">
                                    <CheckmarkIcon v-if="applicant.hasEmailedFiles" class="checkmark-icon"/>
                                    <CheckmarkIcon v-else class="checkmark-icon hidden-icon"/>
                                </td>  <!-- check emailed files -->
                                <td></td> 
                                <td class="checkmark-column">
                                    <CheckmarkIcon v-if="applicant.usedPlatformCV" class="checkmark-icon"/>
                                    <CheckmarkIcon v-else class="checkmark-icon hidden-icon"/>
                                </td>  <!-- check platform CV -->
                                <td></td> 
                                <td>
                                    <div class="icon-buttons">
                                        <button title="Preview Applicant" @click="previewApplicant(applicant)" class="icon-button">
                                            <InfoIcon style="color:var(--page-header);" class="icon-button-icon"/>
                                        </button>
                                        <button @click="toggleShortlist(applicant)" :title="applicant.isShortlisted == true ? 'Remove from Shortlist':'Add to Shortlist'" style="color: var(--green);" class="icon-button">
                                            <UserCheckIcon v-if="applicant.isShortlisted" style="margin-top:0.01rem;margin-right:-0.3;" class="icon-button-icon"/>
                                            <UserCheckIcon v-else style="margin-top:0.01rem;margin-right:-0.3;" class="icon-button-icon not-selected"/>
                                        </button>
                                        <button title="Delete Candidate" @click="setForDelete(applicant)"  style="color: var(--red);" class="icon-button">
                                            <TrashIcon class="icon-button-icon"/>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                        
                            <!--  -->

                        </tbody>
                    </table>
                    <div v-if="!loading" class="custom-pagination" style="margin-top:2rem;">
                            <button class="btn btn-default btn-sm pager-btn" :disabled="currentPage === 1" @click="prevPage">Prev</button>
                            <button class="btn btn-default btn-sm pager-btn" :disabled="applicants.length < 20" @click="nextPage">Next</button>
                    </div>  

            </div>
    </div>
    <ToastMessage 
        ref="applicantToast"
        :message="toast.message"
        :success="toast.success"/>
     <WarningOptionsModal
            ref="delApplicant"
            :body="this.delModal.body"
            :title="this.delModal.title"
            :close-modal="this.delModal.closeModal"
            :yes-selected="this.delModal.yesSelected"
            :yes-button-label="this.delModal.yesButtonLabel"
            :no-button-label="this.delModal.noButtonLabel"
            :modal-id="this.delModal.modalId"
            loading-button-label="Deleting Applicant..."
            />
    <WarningOptionsModal
            ref="delAllApp"
            :body="this.delAllModal.body"
            :title="this.delAllModal.title"
            :close-modal="this.closeDelAllModal"
            :yes-selected="this.deleteAll"
            :yes-button-label="this.delAllModal.yesButtonLabel"
            :no-button-label="this.delAllModal.noButtonLabel"
            :modal-id="this.delAllModal.modalId"
            loading-button-label="Deleting All Vacancies..."
            />
    <PreviewApplicantModal :applicant="previewedApplicant"
                        :toggle-shortlist="toggleShortlistFromPreview"
                        :set-for-delete="setForDeleteFromPreview"
                        ref="previewApplicant"
                        modal-id="previewApplicant"/>
</template>
<script>
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import TrashIcon from '@/components/IconComponents/TrashIcon.vue';
import CloseIcon from '@/components/IconComponents/CloseIcon.vue';
import SearchIcon from '@/components/IconComponents/SearchIcon.vue';
import UserCheckIcon from '@/components/IconComponents/UserCheckIcon.vue';
// import UserUncheckIcon from '@/components/IconComponents/UserUncheckIcon.vue';
import CheckmarkIcon from '@/components/IconComponents/CheckmarkIcon.vue';
import DataTable from 'datatables.net-dt';  
import { toggleApplicantShortlistAsync, deleteApplicantAsync } from '@/services/employers/applicantsService';
import ToastMessage from '@/components/modals/ToastMessage.vue'
import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
import InfoIcon from '@/components/IconComponents/InfoIcon.vue';
import PreviewApplicantModal from '@/components/modals/PreviewApplicantModal.vue';
export default {
    components:{
        LoadingIndicator, 
        TrashIcon, 
        CloseIcon, 
        SearchIcon, 
        UserCheckIcon, 
        CheckmarkIcon,
        ToastMessage,
        WarningOptionsModal,
        InfoIcon,
        PreviewApplicantModal

    },
    computed:{
        applicants(){
            return this.$store.getters["jobApplicants/getApplicants"] || [];       
        },
        applicantsMeta(){
            return this.$store.getters["jobApplicants/getApplicantsMetaData"] || null;       
        },
        vacancy(){
            return this.$store.getters["jobApplicants/getVacancy"] || {};
        }
    },
     mounted(){
        this.loadInitPage(1);
        this.table = new DataTable('#myTable', {
                       dom: 'rt',
                       scrollY: 300,
                       scrollCollapse: false,
                       ordering: false,
                       paging: false,
                       searching: false
            });
    },
    data(){
        return {
          
            searchQuery: '',
            table: null,
            currentPage: 1,
            totalPages: 0,
            pagerPages: [],
            pageSize: 10,
            totalRecords: 0,

            loading: true,
            modal:{
                caption:"",
                message:""
            },
            modalButtonLabel:'Close',
            modalId:"empVac",
            isSearch:false,
            searchBody:{
                searchTerm:"",
                jobId:""
            },
            delModal:{
                title:"",
                body:"",
                modalId:"delApp",
                yesButtonLabel:"Yes",
                noButtonLabel:"No",
                closeModal: null,
                yesSelected: null
            },
             delAllModal:{
                title:"Delete All Applicants",
                body:"<p><b>WARNING!</b><br/> You are about to permanently delete all your applicants. Note that this is action is irreversible.<p/><p>Are you sure want to permanently delete all your applicants?</p>",
                modalId:"delAllVApp",
                yesButtonLabel:"Delete All",
                noButtonLabel:"Cancel"
            },
            editModal:{
                modalId:"editVac",
                vacancy: null
            },
            eyeButtonDisabled: false,
            searchBtnClicked: false,
            cancelBtnClicked: false,
            deleteAllBtnClicked: false,
            toast:{
                message:"",
                success:true
            },
            previewedApplicant:{}

        };
    },
    methods:{
        showDeleteAllOptions(){
            this.showDelAllModal();
        },
         async loadInitPage(){ //load the first page upon page visit
            try{
            this.cancelBtnClicked = true; //for when a user cancels search. Just keep it here
            this.currentPage = 1;
            this.isSearch = false;
            this.searchBody.searchTerm = "";
            let data = {
                jobId: this.vacancy.jobId,
                page: this.currentPage
                }
                await this.$store.dispatch("jobApplicants/getApplicantsAsync", data);
                
            this.loading = false;
            this.cancelBtnClicked = false;
            }catch(e){
                this.loading = false;
                this.cancelBtnClicked = false;
                //this.modal.caption = e.reason;
                //this.modal.message = e.message;
               // this.showModal();

                let message = e.message == 'Failed to fetch' ? 'Unable to get applicants. Check your internet connection or refresh the page.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage(); 
            }
        },
        
         async loadInitPageForSearch(){ //load the first page upon search
            try{
            this.searchBtnClicked = true;
            this.currentPage = 1;
            this.searchBody.jobId = this.vacancy.jobId; //set jobId
            await this.$store.dispatch("jobApplicants/searchApplicantsAsync", {
                data: this.searchBody,
                page: this.currentPage
            });
            this.isSearch = true;
            this.loading = false;
            this.searchBtnClicked = false;
            }catch(e){
                this.loading = false;
                this.searchBtnClicked = false;
                //this.modal.caption = e.reason;
                //this.modal.message = e.message;
               // this.showModal();

                let message = e.message == 'Failed to fetch' ? 'Unable to get applicants search results. Check your internet connection or try again.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage();
            }
        },
        setForDelete(applicant){
            this.delModal.title = "Delete Applicant",
            this.delModal.body = `<b>WARNING!</b></br>You are about to permanently delete ${applicant.fullname} as an applicant.` +
                                 ` Note that this action is irreversible.<br>`+
                                 `Are you sure you want to permanently delete them as an applicant?</br>`;
            this.delModal.yesSelected = async() => await this.deleteApplicant(applicant);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
        
        async goToPage(page) {
            try{
                if(!this.isSearch){ 
                    
                let data = {
                    jobId: this.vacancy.jobId,
                    page
                }
                await this.$store.dispatch("jobApplicants/getApplicantsAsync", data);
                }else{
                    await this.$store.dispatch("jobApplicants/searchApplicantsAsync", {
                    data: this.searchBody,
                    page: page
                });
                }
                this.$nextTick(() => {
                        //this.$refs.tableContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        window.scrollTo({top: 0,behavior: 'smooth'});
                    });
            }catch(e){
               let message = e.message == 'Failed to fetch' ? 'Unable to navigate to page. Check your internet connection.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage(); 
            }
        },
          async prevPage() {
            window.scrollTo({top: 0,behavior: 'smooth'});
            if(this.currentPage > 1){

                await this.goToPage(this.currentPage -= 1);
            }
        },
        async nextPage() {
            window.scrollTo({top: 0,behavior: 'smooth'});
            await this.goToPage(this.currentPage += 1);
        },
        closeDelAllModal(){
            this.$refs.delAllApp.hide();
        },
          async deleteAll(){
             try{
            this.closeDelAllModal();
            this.deleteAllBtnClicked = true;
            await this.$store.dispatch("jobApplicants/deleteAllJobApplicantsAsync", this.vacancy.jobId);
            this.deleteAllBtnClicked = false;
             this.toast = {
                    message:"All your applicants have been permanently deleted",
                    success: true
            }
            this.showToastMessage();
            }catch(e){
                this.deleteAllBtnClicked = false;
               this.toast = {
                    message:"Unable to permanently delete all applicants. Please check your connection or try again later",
                    success: false
                }
                this.showToastMessage();
            }
        },
        async toggleShortlist(applicant){
            try{
                let response = await toggleApplicantShortlistAsync({
                    applicantId: applicant.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    applicant.isShortlisted = response.isShortlisted;
                    this.$store.dispatch("jobApplicants/updateApplicants", applicant);
                    let message = response.isShortlisted == true ? `${applicant.fullname} has been added to Shortlist`:`${applicant.fullname} has been removed from Shortlist`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = applicant.isShortlisted == true ? `Failed to remove ${applicant.fullname} from Shortlist. Check your connection or try again later`: `Failed to add ${applicant.fullname} to Shortlist. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();
                
            }
        },
        async deleteApplicant(applicant){
             try{
                 this.closeDelModal();
                let response = await deleteApplicantAsync({
                    applicantId: applicant.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    
                    this.$store.dispatch("jobApplicants/removeAPermanentlyDeletedApplicant", applicant.applicantId);
                    
                    let message = `${applicant.fullname} has been permanently deleted as an Applicant`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = `Failed to delete ${applicant.fullname} as an Applicant. Check your connection or try again later`
                    this.toast = {
                        message: message,
                        success: false
                    }
                    this.showToastMessage();
            }
        },
        showToastMessage(){
             this.$nextTick(() => {
                if(this.$refs.applicantToast != null){
                    this.$refs.applicantToast.show();
                }
                });
        },
        showDelModal(){
            this.$refs.delApplicant.show();
        },
        closeDelModal(){
            this.$refs.delApplicant.hide();
        },
        showDelAllModal(){
            this.$refs.delAllApp.show();
        },
        previewApplicant(applicant){
            this.previewedApplicant = applicant;
            this.$refs.previewApplicant.show();
        },
        toggleShortlistFromPreview(){
            this.$refs.previewApplicant.hide();
            setTimeout(() => this.toggleShortlist(this.previewedApplicant),1000);
        },
        setForDeleteFromPreview(){
            this.$refs.previewApplicant.hide();
            setTimeout(() => this.setForDelete(this.previewedApplicant), 1000);
        }
    }
}
</script>
<style scoped>

 .display{
        font-family: var(--body-font)!important;
 }

 th{
        font-family: var(--body-font-bold)!important;
        flex:1;
   }


.total{
    color:var(--placeholder);
}

.delete-all{
    padding-top:0.35rem;
}

.page-count{
    color: var(--page-header);
    /* font-family:var(--page-header-font); */
    font-family: var(--heading-font-regular);
    font-size: 1rem;
}

.not-selected{
    opacity:0.5;
    color:var(--placeholder);
}

.checkmark-column{
 display: grid;
}

.checkmark-icon{
    justify-self: center;
    margin-top:0.25rem;
    color:var(--green);
}

.hidden-icon{
    opacity:0;
}

.pager-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border:0px;
    background: transparent;
    color: var(--page-header)!important;
    cursor: pointer;
    font-size:0.8rem;
    text-transform:uppercase;
    font-family: var(--heading-font-regular);
}
.pager-btn.current {
    background: var(--primary, var(--primary-color, #007bff));
    color: #fff;
    border-color: var(--primary, var(--primary-color, #007bff));
}
.pager-btn:disabled {
    opacity: 0.5;
    cursor: default;
    color:var(--placeholder)!important;
}
    
.custom-pagination {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-top: 12px;
}

     .icon-buttons{
        display: flex;
        justify-content: right;
    }

     .icon-button{
        border:0px;
        background: transparent;
    }

    .icon-button-icon, .checkmark-icon{
        height:1rem;
    }

.app-table-head{
    display:grid;
    grid-template-columns: 1fr 1fr 1fr;
   
}



.table-actions {
    margin-top:0.5rem;
    display: flex;

}


.search-query{
    padding:0.5rem 0.8rem;
     width:25rem;
    margin-bottom:1rem;
}

.table-title {
    font-family:var(--page-header-font);
    color: var(--page-header);
    font-size:1.2rem;
}

.table-header {
    display: flex;
    justify-content: space-between;
}
    .theme-card{
    margin:0rem;
    border-radius:18px;
    background-color: var(--intro-background);
    }

.tables{
    margin-top:1rem;
}

.table-content {
    overflow-x: auto;
}

.search-btn{
    height:2.2rem;
    width: 2.2rem;
    background-color: var(--page-header)!important;
    color:var(--enterprise-button)!important;
}

.table-actions .search-btn {
    font-size:0.9rem;
    border-radius: 6px;
    border:0px;
    border-radius: 100px;
    background: var(--icon-blue);
    margin-right:0.5rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0.5rem 0.6rem;
}


/**Navbar */

   
    .location{
        border-left:1px solid var(--sidenav-link)!important;
        border-right:1px solid var(--sidenav-link)!important;
        padding:0rem 1rem;
    }


.page-nav{
        margin-top:0rem;
    }

    .breadcrumb{
        margin:0px!important;
    }

    .jobs-nav{
        background-color: var(--intro-background);
        border-bottom:0px;
        display:grid;
        grid-template-rows:auto auto;
        row-gap:0.7rem;
        padding:1rem;
        border-radius:18px;
    }

    .title{
        color:var(--page-header);
        font-family: var(--heading-font-bold);
        font-size: 1.6rem;
    }

    

     .breadcrumb-link{
            color:var(--navlink);
            text-decoration: none;
    }

    .job-details{
        display:grid;
        grid-template-rows: auto auto;
        row-gap: 0.1rem;
    }

    .sub-details{
        display: flex;
        column-gap: 1rem;
        color:var(--sidenav-link);
        font-size:0.9rem;
        font-family: var(--heading-font-regular);
    }

    

   

    nav a.router-link-exact-active {
            color: var(--navlink-active);
    }

/** Navbar */

/** Table */

/* Datatable base */
.table-content {
    overflow-x: auto;
}

#myTable {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--font-family, Arial, Helvetica, sans-serif);
    font-size: 14px;
    color: var(--text-color, #222);
}

#myTable thead th {
    text-align: left;
    padding: 10px 12px;
    background: var(--table-header-bg, #f7f8fa);
    color: var(--table-header-color, #111);
    border-bottom: 1px solid rgba(0,0,0,0.08);
    position: sticky;
    top: 0;
    z-index: 2;
}



#myTable tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(0,0,0,0.04);
    vertical-align: middle;
}

/* Row hover and stripe */
#myTable tbody tr:nth-child(odd) {
    background: var(--table-row-odd, #fff);
}
#myTable tbody tr:nth-child(even) {
    background: var(--table-row-even, #fbfbfb);
}
#myTable tbody tr:hover {
    background: rgba(0,0,0,0.03);
}

/** Table */
</style>